module.exports = __webpack_public_path__ + "img/img-5mobile.c5f367a5.png";